import React from "react";
import { CheckCircleFilled } from "@ant-design/icons";
import { Typography } from "antd";
import { HomePhoneFeature } from "../../../../../types/homePhone";
import PRODUCT_DETAIL from "../constants";

const { Title } = Typography;

interface SpecCardProps {
  features: HomePhoneFeature[];
}

const SpecCard: React.FC<SpecCardProps> = ({ features }) => (
  <div className="pd-spec-card">
    <Title level={5} className="pd-spec-title">
      {PRODUCT_DETAIL.LABELS.SPEC_TITLE}
    </Title>
    <ul className="pd-spec-grid">
      {features.map((feature) => (
        <li key={feature.label} className="pd-spec-item">
          <CheckCircleFilled className="pd-spec-icon" aria-hidden="true" />
          <span>{feature.label}</span>
        </li>
      ))}
    </ul>
  </div>
);

export default SpecCard;
